import React, { useEffect, useState } from "react";
import { Button, Divider, Popover, Space, Table, Tooltip } from "antd";
import TableTitle from "../../../../../../common/TableTitle";
import { appTheme } from "../../../../../../../config/theme";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faComment,
  faExclamationCircle,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import { ModalCommentaireBalance } from "../../../../../../modals/clients/ModalCommentaireBalance";
import FormLabel from "../../../../../../common/Form/FormLabel";
import { SearchHeader } from "../../../../../../layout/header/HeaderList";

const HistoriqueBalanceProvisoireDefinitif = ({
  balanceData,
  setBalanceData,
  mission,
  chargement,
  handleSubmit,
  setIsTaskSave,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(null);
  const [filtersItems, setFiltersItems] = useState(balanceData || []);

  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 200,
    },
  });

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      ...sorter,
    });
  };

  const handleModalOpen = (data) => {
    setBalance(data);
    setIsModalOpen((prevState) => !prevState);
  };

  useEffect(() => {
    setFiltersItems(balanceData);
  }, [balanceData]);

  const handleSearchChange = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    const filtered = balanceData.filter((item) => {
      const compteProvMatch = item.numeroCompteProv
        ?.toString()
        .toLowerCase()
        .includes(searchTerm);

      const compteDefMatch = item.numeroCompteDef
        ?.toString()
        .toLowerCase()
        .includes(searchTerm);

      const libelleProvMatch = item.libelleProv
        ?.toLowerCase()
        .includes(searchTerm);

      const libelleDefMatch = item.libelleDef
        ?.toLowerCase()
        .includes(searchTerm);

      const creditDefMatch = item.creditDef
        ?.toString()
        .toLowerCase()
        .includes(searchTerm);

      const creditProvMatch = item.creditProv
        ?.toString()
        .toLowerCase()
        .includes(searchTerm);

      return (
        compteProvMatch ||
        compteDefMatch ||
        libelleProvMatch ||
        libelleDefMatch ||
        creditDefMatch ||
        creditProvMatch
      );
    });

    setFiltersItems(filtered);
  };

  const columns = [
    {
      title: () => <TableTitle>#</TableTitle>,
      render: (_, record, index) => <>{index + 1}</>,
      width: 40,
    },
    {
      title: () => <TableTitle>Compte Prov</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.isExistProv ? "" : record.numeroCompteProv}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Libellé Prov</TableTitle>,
      dataIndex: "col1",
      width: 400,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.isExistProv ? "" : record.libelleProv}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Débit Prov</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.debitProv || 0).toLocaleString("fr")}
        </div>
      ),
    },
    {
      title: () => <TableTitle>Crédit Prov</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.creditProv || 0).toLocaleString("fr")}
        </div>
      ),
    },
    {
      title: () => <TableTitle>Compte Def</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.isExistDef ? "" : record.numeroCompteDef}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Libellé Def</TableTitle>,
      dataIndex: "col1",
      width: 400,
      render: (_, record) => (
        <span className="fw-bolder" style={{ fontSize: "14px" }}>
          {record.isExistDef ? "" : record.libelleDef}
        </span>
      ),
    },
    {
      title: () => <TableTitle>Débit Def</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.debitDef || 0).toLocaleString("fr")}
        </div>
      ),
    },
    {
      title: () => <TableTitle>Crédit N-1</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {(record.creditDef || 0).toLocaleString("fr")}
        </div>
      ),
    },
    {
      title: () => <TableTitle>DIFF SD</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {record.debitProv - record.debitDef}
        </div>
      ),
    },
    {
      title: () => <TableTitle>DIFF SC</TableTitle>,
      dataIndex: "col1",
      width: 100,
      render: (_, record) => (
        <div className="text-end pe-0 fw-bolder" style={{ fontSize: "14px" }}>
          {record.creditProv - record.creditDef}
        </div>
      ),
    },
    {
      title: () => <TableTitle>COM</TableTitle>,
      dataIndex: "commentaire",
      width: 40,
      render: (_, record) => (
        <div className="">
          <Space>
            {record.commentaire && (
              <Popover
                placement="top"
                title={<FormLabel label={"Commentaire"} />}
                content={
                  <>
                    <Divider />
                    <span className="fw-bolder" style={{ fontSize: "14px" }}>
                      {record.commentaire || ""}
                    </span>
                  </>
                }
              >
                <Button
                  icon={<FontAwesomeIcon icon={faExclamationCircle} />}
                  color={""}
                />
              </Popover>
            )}
            <Tooltip title="Editer un commentaire">
              <Button
                shape="circle"
                style={{
                  backgroundColor: appTheme.colors.primary,
                  color: "white",
                }}
                icon={<FontAwesomeIcon icon={faComment} />}
                onClick={() => handleModalOpen(record)}
              />
            </Tooltip>
          </Space>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="my-5">
        <div className="d-flex justify-content-end align-items-end pb-10">
          <Tooltip title="Résultats">
            <Button
              disabled={
                mission.isCloture === 1 || mission.isClotureProvisoire === 1
              }
              size={"large"}
              // loading={loading}
              style={{
                backgroundColor: appTheme.colors.primary,
                color: "white",
              }}
              icon={
                <FontAwesomeIcon style={{ paddingRight: "10" }} icon={faSave} />
              }
              onClick={handleSubmit}
            >
              {!chargement && (
                <span className="indicator-label text-white">Enregistrer</span>
              )}
              {chargement && (
                <span className="indicator-progress text-white">
                  Patientez svp...
                </span>
              )}
            </Button>
          </Tooltip>
        </div>
        {(balanceData ?? []).length > 0 && (
          <div className="card-header border-0 pt-2">
            <SearchHeader
              placeholder="Rechercher par le numero de compte, le libellé..."
              handleSearch={handleSearchChange}
            />
          </div>
        )}
        <div className="table-responsive">
          <Table
            /* onRow={(record) => {
              return {
                onDoubleClick: () => {
                  handleModalOpen(record);
                },
              };
            }} */
            rowClassName={() => `cursor-pointer h-3px p-0 m-0 lh-0.5`}
            columns={columns}
            rowKey={(record, index) => index}
            dataSource={filtersItems ?? []}
            pagination={tableParams.pagination}
            onChange={handleTableChange}
            scroll={{ x: 1300 }}
            loading={chargement || loading}
            rowSelection
            size={"small"}
          />
        </div>
      </div>
      <ModalCommentaireBalance
        setBalanceData={setBalanceData}
        balanceData={balanceData}
        balance={balance}
        visible={isModalOpen}
        handleVisibility={handleModalOpen}
        loading={loading}
        isIntang={false}
        setLoading={setLoading}
        setIsTaskSave={setIsTaskSave}
      />
    </>
  );
};

export { HistoriqueBalanceProvisoireDefinitif };
